import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { FaVideo, FaCalendarCheck, FaClock, FaCheckCircle } from 'react-icons/fa';

const MeetingsKpiGrid = ({ stats }) => {
  const kpiItems = [
    {
      title: "Total Meetings",
      value: stats.total || 0,
      icon: <FaVideo size={16} />,
      colorClass: "text-info",
      bgClass: "bg-info bg-opacity-10"
    },
    {
      title: "Upcoming / Booked",
      value: stats.booked || 0,
      icon: <FaCalendarCheck size={16} />,
      colorClass: "text-success",
      bgClass: "bg-success bg-opacity-10"
    },
    {
      title: "Completed / Expired",
      value: stats.expired || 0,
      icon: <FaCheckCircle size={16} />,
      colorClass: "text-secondary",
      bgClass: "bg-secondary bg-opacity-10"
    },
    {
      title: "Active Slots",
      value: stats.booked || 0,
      icon: <FaClock size={16} />,
      colorClass: "text-warning",
      bgClass: "bg-warning bg-opacity-10"
    }
  ];

  return (
    <Row className="g-3 mb-4">
      {kpiItems.map((item, index) => (
        <Col xs={6} md={3} key={index}>
          <div className="meetings-kpi-card">
            <div className="d-flex align-items-center justify-content-between mb-2">
              <span className="meetings-kpi-title">{item.title}</span>
              <div className={`meetings-kpi-icon ${item.colorClass} ${item.bgClass}`}>
                {item.icon}
              </div>
            </div>
            <h3 className="meetings-kpi-value">{item.value}</h3>
          </div>
        </Col>
      ))}
    </Row>
  );
};

export default MeetingsKpiGrid;
